import { useState } from "react";
import { createStock, updateStockCoverage } from "./StockService";

export default function StockForm({ onSaved }) {
  const [symbol, setSymbol] = useState("");
  const [name, setName] = useState("");
  const [exchange, setExchange] = useState("");
  const [country, setCountry] = useState("");
  const [sector, setSector] = useState("");
  const [industry, setIndustry] = useState("");
  const [sectors, setSectors] = useState("");
  const [countries, setCountries] = useState("");
  const [isin, setIsin] = useState("");
  const [currency, setCurrency] = useState("INR");
  const [marketCap, setMarketCap] = useState("");
  const [marketCapDate, setMarketCapDate] = useState("");
  const [capCategoryCode, setCapCategoryCode] = useState("");
  const [capCategoryName, setCapCategoryName] = useState("");
  const [capAsOfDate, setCapAsOfDate] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const created = await createStock({
      symbol,
      name,
      exchange,
      country,
      sector,
      industry,
      isin,
      currency,
      marketCap: marketCap ? Number(marketCap) : null,
      marketCapDate: marketCapDate || null,
      capCategoryCode: capCategoryCode || null,
      capCategoryName: capCategoryName || null,
      capAsOfDate: capAsOfDate || null,
    });
    const stockId = created?.id;
    if (stockId) {
      const sectorList = sectors
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const countryList = countries
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      await updateStockCoverage(stockId, { sectors: sectorList, countries: countryList });
    }
    setSymbol("");
    setName("");
    setExchange("");
    setCountry("");
    setSector("");
    setIndustry("");
    setSectors("");
    setCountries("");
    setIsin("");
    setCurrency("INR");
    setMarketCap("");
    setMarketCapDate("");
    setCapCategoryCode("");
    setCapCategoryName("");
    setCapAsOfDate("");
    if (onSaved) onSaved();
  };

  return (
    <form className="card stack-form" onSubmit={submit}>
      <h3>Add Stock</h3>
      <input value={symbol} onChange={(e) => setSymbol(e.target.value)} placeholder="Symbol" required />
      <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" required />
      <input value={exchange} onChange={(e) => setExchange(e.target.value)} placeholder="Exchange" />
      <input value={country} onChange={(e) => setCountry(e.target.value)} placeholder="Country" />
      <input value={sector} onChange={(e) => setSector(e.target.value)} placeholder="Sector" />
      <input value={industry} onChange={(e) => setIndustry(e.target.value)} placeholder="Industry" />
      <input
        value={sectors}
        onChange={(e) => setSectors(e.target.value)}
        placeholder="Sectors (comma separated)"
      />
      <input
        value={countries}
        onChange={(e) => setCountries(e.target.value)}
        placeholder="Countries (comma separated)"
      />
      <input value={isin} onChange={(e) => setIsin(e.target.value)} placeholder="ISIN" />
      <input value={currency} onChange={(e) => setCurrency(e.target.value)} placeholder="Currency" />
      <input
        type="number"
        value={marketCap}
        onChange={(e) => setMarketCap(e.target.value)}
        placeholder="Market cap"
      />
      <input
        type="date"
        value={marketCapDate}
        onChange={(e) => setMarketCapDate(e.target.value)}
        placeholder="Market cap date"
      />
      <select value={capCategoryCode} onChange={(e) => setCapCategoryCode(e.target.value)}>
        <option value="">Cap category</option>
        <option value="LARGE_CAP">Large Cap</option>
        <option value="MID_CAP">Mid Cap</option>
        <option value="SMALL_CAP">Small Cap</option>
      </select>
      <input
        value={capCategoryName}
        onChange={(e) => setCapCategoryName(e.target.value)}
        placeholder="Cap category name"
      />
      <input
        type="date"
        value={capAsOfDate}
        onChange={(e) => setCapAsOfDate(e.target.value)}
        placeholder="Cap as of date"
      />
      <button className="btn btn-primary" type="submit">
        Save
      </button>
    </form>
  );
}
